import { apiSlice } from './apiSlice'

export const newsLetterSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLanguagesFromEmail: builder.query({
      query: (userEmail: string) => ({
        url: `/newsletter/subscription`,
        method: 'POST',
        body: {
          email: userEmail,
        },
      }),
    }),
  }),
})

export const { useGetLanguagesFromEmailQuery } = newsLetterSlice
